export default __webpack_public_path__ + "static/media/icon-cotizacion.22c521d5.svg";